import axios from "axios";
import APP_CONSTANT from "../../config/config";
import qs from "qs";
//import FormData from 'form-data';
export const GetFilesAxiosPDF = async function (props = {}) {
  let token = localStorage.getItem("isloggedIn");
  let userId = localStorage.getItem("userId");
  let customerNo = localStorage.getItem("customerNumber");

  //let formData = new FormData();
  //formData.append("customerNo", customerNo);
  //formData.append("customerNumber", customerNo);
  //formData.append("userId", userId);
  //formData.append("delivery_order", props.createItems.delivery_order);

  var config = {
    method: 'get',
    url: `${process.env.REACT_APP_TA_API_URL}${props.url}?customer_no=${customerNo}&user_id=${userId}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    /* data : formData */
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        } else {
          console.log("Error", res.data);
          reject(res);
        }
      })
      .catch((err) => {
        console.log(err)
        reject(err);
      })
  });

};


export const PostFilesAxios = async function (props = {}) {
  let token = localStorage.getItem("isloggedIn");
  let userId = localStorage.getItem("userId");
  let customerNo = localStorage.getItem("customerNumber");

  let formData = new FormData();
  //formData.append("customerNo", customerNo);
  //formData.append("customerNumber", customerNo);
  //formData.append("userId", userId);
  formData.append("delivery_order", props.createItems.delivery_order);

  var config = {
    method: 'put',
    url: `${process.env.REACT_APP_TA_API_URL}${props.url}?customer_no=${customerNo}&user_id=${userId}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        } else {
          console.log("Error", res.data);
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
        console.log(err)
      })
  });

};

export default PostFilesAxios

export const PatchFilesAxios = async function (props = {}) {
  let token = localStorage.getItem("isloggedIn");
  let userId = localStorage.getItem("userId");
  let customerNo = localStorage.getItem("customerNo");

  let formData = new FormData();
  formData.append("customerNo", customerNo);
  formData.append("customerNumber", customerNo);
  formData.append("userId", userId);
  formData.append("delivery_order", props.createItems.delivery_order);


  var config = {
    method: 'patch',
    url: `${APP_CONSTANT.BASE_COMMON}${props.url}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
    },
    data: formData
  };
  return new Promise((resolve, reject) => {
    axios(config)
      .then((res) => {
        if (res.status === 200) {
          resolve(res);
        } else {
          console.log("Error", res.data);
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
        console.log(err)
      })
  });

};
